import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import { getAgents } from './api';
export const useAgents = (initialParams) => usePaginatedEndpoint({
    endpoint: getAgents,
    itemsSelector: (data) => data.agents,
    totalSelector: (data) => data.number_of_agents,
    initialParams: Object.assign({ sortKey: 'display_name' }, initialParams),
});
